/** Admin API — must match GHMS_Back (port 3000) and GHMS_KOT env */
const ADMIN_API_URL = 'https://api.gnanams.com/api/v1.0/';

function normalizeApiUrl(url) {
  if (!url || typeof url !== 'string') {
    return ADMIN_API_URL;
  }
  const trimmed = url.trim();
  return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
}

export default {
  apiUrl: normalizeApiUrl(process.env.VUE_APP_API_URL || ADMIN_API_URL),
};
